<template>
  <div class="content if-profile report-tab">
    <div class="md-layout financal-report">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
      >
        <VRHeader :headerData="this.headerData" />
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4"
      >
        <div class="md-layout">
          <div class="md-layout-item p-0">
            <md-card class="if_card">
              <md-card-header>Company Context</md-card-header>
              <!-- <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-50">
                  <md-card-header class="md-card-header-icon">
                    <h1 class="md-title text-left profile-title">
                      Company Context<br/>
                    </h1>
                  </md-card-header>
                </div>
              </div>-->
              <md-card-content class="company-context">
                <div class="md-layout p-4">
                  <div class="md-layout-item md-medium-size-100 md-size-100">
                    <profile-card header-color="blue" class="text-card">
                      <template slot="header">
                        <h4
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0 m-0"
                        >
                          History
                        </h4>
                      </template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>
                            Fill in a description of the company’s founding,
                            history and progression, including industry,
                            location and markets. You will be able to edit this
                            text in the future. If you choose not to write
                            anything, this section will not appear in the final
                            report.
                          </p>
                          <span class="md-caption">
                            Character count: ({{ context_history.length }}/{{
                              this.vestimateReport.maxContextLength
                            }})
                          </span>
                          <md-card-content class="context">
                            <md-field>
                              <md-textarea
                                :class="
                                  this.$route.path.includes('sample')
                                    ? 'disabled-item'
                                    : ''
                                "
                                v-model="context_history"
                              ></md-textarea>
                            </md-field>
                          </md-card-content>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-100">
                    <profile-card header-color="blue" class="text-card">
                      <template slot="header">
                        <h4
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0 m-0"
                        >
                          Products and Customers
                        </h4>
                      </template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>
                            Upload or fill in a description of the company’s
                            products or services, and what need(s) they are
                            designed to meet. Include a description of the
                            client base, consistency and account sizes, the
                            methods of service or product delivery and recent
                            upgrades or planned changes. You will be able to
                            edit this text in the future. If you choose not to
                            write anything, this section will not appear in the
                            final report.
                          </p>
                          <span class="md-caption">
                            Character count: ({{ context_products.length }} /
                            {{ this.vestimateReport.maxContextLength }})
                          </span>
                          <md-card-content class="context">
                            <md-field>
                              <md-textarea
                                :class="
                                  this.$route.path.includes('sample')
                                    ? 'disabled-item'
                                    : ''
                                "
                                v-model="context_products"
                              ></md-textarea>
                            </md-field>
                          </md-card-content>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-100">
                    <profile-card header-color="blue" class="text-card">
                      <template slot="header">
                        <h4
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0 m-0"
                        >
                          Operations
                        </h4>
                      </template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>
                            Fill in in a description of operations and staff.
                            Include a company "map": the size and type of
                            departments, the employee base, levels of training
                            and identification of key employees by role. You
                            will be able to edit this text in the future. If you
                            choose not to write anything, this section will not
                            appear in the final report.
                          </p>
                          <span class="md-caption">
                            Character count: ({{ context_operations.length }}/{{
                              this.vestimateReport.maxContextLength
                            }})
                          </span>
                          <md-card-content class="context">
                            <md-field>
                              <md-textarea
                                :class="
                                  this.$route.path.includes('sample')
                                    ? 'disabled-item'
                                    : ''
                                "
                                v-model="context_operations"
                              ></md-textarea>
                            </md-field>
                          </md-card-content>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                  <div
                    class="md-layout-item md-medium-size-100 md-size-100 mb-4"
                  >
                    <md-button
                      @click="saveContext()"
                      type="button"
                      class="md-info md-default"
                      >Save</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VRHeader from "./_partials/VRHeader";
import { ProfileCard } from "@/components";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    ProfileCard,
    VRHeader,
  },
  props: ["headerData"],
  data() {
    return {
      operations_length: 0,
      history_length: 0,
      products_length: 0,
      context_history: "",
      context_products: "",
      context_operations: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      displayArea: (state) => state.user.vestimate_report.data.MR.area,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      companyName: (state) =>
        state.user.vestimate_report.data.input_structure["Company Name"][
          "value"
        ],
    }),
  },
  methods: {
    ...mapActions({
      save: "user/saveVestimateReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    saveContext() {
      this.loading = true;
      let params = {};

      params.history_context = this.context_history;
      params.products_context = this.context_products;
      params.operations_context = this.context_operations;

      params = _.omitBy(params, _.isEmpty);

      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "valuation_text",
        action: "save",
        ...params,
      })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          if (res.success) {
            this.params = {};
            this.alertSuccess("Data loaded.");
          } else {
            this.alertError("An error occurred. We have been notified.");
          }
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
  },
  mounted() {
    if (!this.$route.path.includes("sample")) {
      this.context_history = this.vestimateReport.context_text.context_history
        ? this.vestimateReport.context_text.context_history
        : "";
      this.context_products = this.vestimateReport.context_text.context_products
        ? this.vestimateReport.context_text.context_products
        : "";
      this.context_operations = this.vestimateReport.context_text
        .context_operations
        ? this.vestimateReport.context_text.context_operations
        : "";
    } else {
      this.context_history =
        "Main Street Plumbing is a well know plumbing and HVAC contractor (NAICS 238220) in the Harrisburg, PA metropolitan area. The company was established in 1948 by the grandfather of current owner Tom Jackman. It currently does business from offices at 2200 State Street in Camp Hill, PA 17011." +
        "The company has grown from a one-person operation at its inception into a business operation deploying a fleet of four equipped trucks and nine employees. The company general serves customers throughout the five county Harrisburg region but the majority are concentrated in East Cumberland and West Dauphin counties closest to the Main Street operations center. Main Street Plumbing Sales rank 74 out of 248 similar contractors in the market area. The company enjoys a four-star rating from customers on both Yelp and Home Advisor." +
        "Demand for plumbing services in the Harrisburg area are strong, accounting for more than $494 million revenue per year.";

      this.context_products =
        "Main Street Plumbing is a full service contractor including 24-hour emergency service, bath, kitchen and exterior upgrades and extensive HVAC maintenance and installation contracts. The company’s clientele is approximately 80% residential and 20% commercial, including plumbing repairs (25% of revenue), renovations (50%) and new installations (25%). The repair segment documents high levels of repeat accounts, including both commercial and residential consumers. Fleet vehicles are fully overhauled once per year with regular interim maintenance; tools are likewise regularly updated to accommodate state of the art plumbing practices.";

      this.context_operations =
        "Owner Tom Jackman is engaged full time in the management of the business, overseeing an office staff of one assistant and eight craft employees." +
        "Two line employees are HVAC specialists and all engage in diverse plumbing projects as needed. A rotating set of employees is charged with responding to the company’s 24-hor service line and one has been received special training in modern bath fixture installations including steam baths and showers." +
        "Annual compensation averages $44,100. Employees engage in regular technical training at the office and various local technical academies. The median employee age is 40, and the average length of service is 9 nine years. " +
        "Sample Valuation Report needs company context.";
    }
  },
};
</script>
<style lang="scss">
.company-context {
  .md-card-content.context {
    background-color: #f7f9fa;
    border: 1px solid #a6adaf;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
</style>
